
import { createNamespacedHelpers } from 'vuex'
import MentorTabs from '~/components/pages/education/Mentor/MentorTabs/MentorTabs.vue'
import { gbLocalStorage } from '~/utils/helpers'
import CardsLoader from '~/components/pages/education/ProgramsList/CardsLoader.vue'
import MentorInfo from '~/components/pages/education/Mentor/MentorInfo.vue'
const { mapState } = createNamespacedHelpers('education')
export default {
  name: 'EducationMentor',
  components: { MentorInfo, CardsLoader, MentorTabs },
  data() {
    return {
      initialTab: '',
      isLoading: true,
      selectedTab: '',
      tabs: [
        {
          label: 'Доступные',
          value: 'current',
          icon: 'FileDockList'
        },
        {
          label: 'Активные',
          value: 'active',
          icon: 'FireOutline28'
        },
        {
          label: 'Завершенные',
          value: 'completed',
          icon: 'ArchiveOutline28'
        },
        {
          label: 'Станьте наставником',
          value: 'info',
          icon: 'InfoCircleOutline28'
        }
      ]
    }
  },

  computed: {
    ...mapState(['mentor']),

    initialTabIndex() {
      return this.filteredTabs.findIndex(tab => tab.value === this.initialTab)
    },

    isMentor() {
      return this.$store.state.user.isMentor
    },

    mentorTabsTypes() {
      const defaultTypes = ['current', 'info']
      const mentorTabs = this.mentor?.block?.tabs?.map?.(tab => tab.type)
      if (mentorTabs?.length) {
        return [...defaultTypes, ...mentorTabs]
      }

      return defaultTypes
    },

    filteredTabs() {
      if (this.mentorTabsTypes?.length) {
        return this.tabs?.filter(tab =>
          this.mentorTabsTypes?.includes(tab?.value)
        )
      }

      return []
    }
  },

  async mounted() {
    await this.$store.dispatch('education/getMentorBlockData')
    await this.checkIsMentorVisited()
    if (!this.isMentor) {
      await this.$router.push('/404')
    }
    this.isLoading = false
  },

  methods: {
    async checkIsMentorVisited() {
      const localIsVisited = gbLocalStorage.get('gb-is-mentor-visited')

      if (localIsVisited) {
        this.initialTab = 'current'

        return
      }

      const dbIsVisited = await this.$store.dispatch(
        'education/getIsMentorPageVisited'
      )

      if (dbIsVisited?.visited) {
        this.initialTab = 'current'
      } else {
        this.initialTab = 'info'
        this.$store.dispatch('education/setIsMentorPageVisited')
      }

      gbLocalStorage.set('gb-is-mentor-visited', true)
    },

    selectTab(tab) {
      this.selectedTab = tab
    }
  }
}
